import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="pt-16 md:pt-20">
        <div className="shell flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
          <p className="font-heading text-6xl font-bold text-background-200 md:text-8xl">404</p>
          <h1 className="mt-2 font-heading text-2xl font-semibold text-foreground-950">
            页面不存在或已下架
          </h1>
          <p className="mt-2 max-w-md text-sm text-foreground-600">
            我们找不到这个页面：{location.pathname}
            <br />
            换个入口继续浏览影视作品与资讯吧。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
            >
              浏览电影库
            </Link>
            <Link
              to="/category/news"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
            >
              查看影视资讯
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}